/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".target_f382b7cb{display:block}.host_f382b7cb{position:absolute;left:0;right:0;bottom:0;top:0;pointer-events:none}\n"}]);
export const target = "target_f382b7cb";
export const host = "host_f382b7cb";